import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { usePunditUserContext } from "@circle-react/contexts";

export const useEmailHubBilling = () => {
  // TODO: We have another PR to refactor the currentPlanApi to return
  // the EmailHub subscription
  const { currentPlan, isCurrentPlanLoading } = useCurrentPlanApi();
  const { isLoading: isLoadingPunditContext, currentCommunity } =
    usePunditUserContext();

  const emailHubBilling = currentPlan?.email_hub_billing;
  const billingStatus = emailHubBilling?.billing_status;
  const emailHubBillingFreePeriod = currentPlan?.email_hub_billing?.free_period;

  const isTrialing = currentCommunity?.is_on_trial;
  const isInFreePeriod = !isTrialing && billingStatus === "free_period";
  const isActive = !isTrialing && billingStatus === "active";

  // [EmailHub][BeforeRelease] Check if those are the right conditions
  const isInactive =
    !(isActive || isInFreePeriod || isTrialing) || billingStatus === "inactive";

  return {
    emailHubBilling,
    emailHubBillingFreePeriod,
    isLoading: isCurrentPlanLoading || isLoadingPunditContext,
    billingStatus,
    isTrialing,
    isInFreePeriod,
    isActive,
    isInactive,
  };
};
